export default __webpack_public_path__ + "static/media/slider01.a171e678.png";